export const RootPath = {
  Admin: "admin",
  Data: "data",
  DeveloperAdmin: "developer_admin",
  Financial: "financial",
  ForgotPassword: "forgot-password",
  Labs: "labs",
  Neat: "neat",
  Organization: "organizations",
  Report: "reporting",
  ResetPassword: "reset-password",
  Root: "/",
  Settings: "user-settings",
  SignIn: "sign-in",
  Site: "sites",
  ValidateAccount: "validate-account",
} as const

export type RootPathName = (typeof RootPath)[keyof typeof RootPath]

export const NeatPath = {
  RecommendedActions: "actions",
  ScheduleMisalignment: "schedule-misalignment",
  Variance: "variance",
} as const

export type NeatPathName = (typeof NeatPath)[keyof typeof NeatPath]

export const AdminPath = {
  Bill: ":billId",
  Bills: "bills",
  Credential: ":credentialId",
  Credentials: "credentials",
  Edit: "edit",
  Meter: ":meterId",
  Meters: "meters",
  New: "new",
  Site: ":siteId",
  Sites: "sites",
  User: ":userId",
  Users: "users",
} as const

export type AdminPathName = (typeof AdminPath)[keyof typeof AdminPath]

export const DataPath = {
  Outlier: "outlier",
  QA: "qa",
  Upload: "upload",
} as const

export type DataPathName = (typeof DataPath)[keyof typeof DataPath]

export const ReportPath = {
  CustomReports: "custom-reports",
  Gresb: "gresb",
  Gri: "gri",
  Workbook: ":workbookId",
} as const

export type ReportPathName = (typeof ReportPath)[keyof typeof ReportPath]

export const SitePath = {
  Bill: ":billId",
  Bills: "bills",
  Compliance: "compliance",
  Intervals: "intervals",
  Overview: "overview",
  Performance: "performance",
  Site: ":siteId",
  SiteDetails: "details",
} as const

export type SitePathName = (typeof SitePath)[keyof typeof SitePath]
